const mutations = {
  INITIALIZE(state, { agency }) {
    state.currentAgency = agency
  },
}

export default mutations
